import { render, staticRenderFns } from "./LayoutFooter.vue?vue&type=template&id=791745dc&scoped=true&"
import script from "./LayoutFooter.vue?vue&type=script&lang=js&"
export * from "./LayoutFooter.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFooter.vue?vue&type=style&index=0&id=791745dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791745dc",
  null
  
)

export default component.exports